module.exports = __webpack_public_path__ + "img/CZ60192852.0429acaa.svg";